import { ACCOUNT_TYPE_MODULE_ACTION } from "./account-type-module-action";
export function isModuleActionAllowed({ accountType, module, action }) {
    return ACCOUNT_TYPE_MODULE_ACTION[accountType][module].includes(action);
}
